import React from "react";

import { Avatar, ButtonStandard, Link, ModalBase, Text } from "@performyard/py-components";

import { employeeUrlWithFrom } from "../../../utils/employeeDetailsBreadcrumbs";

type AvatarGroupModalProps = {
	employees: { _id: string; name: string }[];
	isOpen: boolean;
	onClose: () => void;
	title?: string;
	subtitle?: string;
};

const AvatarGroupModal = ({ employees, isOpen, onClose, title = "Employees", subtitle }: AvatarGroupModalProps) => {
	return (
		<ModalBase isOpen={isOpen} onClose={onClose} dangerouslySetClassName="w-[432px]">
			<div className="px-6 pb-4 text-center">
				<Text size="sub-heading" weight="semi-bold">
					{title}
				</Text>
				{subtitle && (
					<Text size="paragraph-2" weight="regular">
						{subtitle}
					</Text>
				)}
			</div>

			<div className="max-h-[320px] overflow-y-auto px-6">
				{employees.map((employee, index) => (
					<div
						key={employee._id}
						className={`flex items-center gap-2 px-2 py-1 ${index % 2 === 0 ? "bg-neutral-1" : ""}`}
					>
						<span className="w-7 shrink-0 text-paragraph-2 text-neutral-7">{index + 1}.</span>
						<Avatar size={20} id={employee._id} name={employee.name} />
						<Link href={employeeUrlWithFrom(employee._id)} forceHardReload={true} underline="never">
							<span className="py-line-clamp-1 text-paragraph-3">{employee.name}</span>
						</Link>
					</div>
				))}
			</div>

			<div className="flex justify-center px-6 pt-6 pb-6">
				<ButtonStandard color="primary" size="large" onClick={onClose} dangerouslySetClassName="w-fit">
					Close
				</ButtonStandard>
			</div>
		</ModalBase>
	);
};

export default AvatarGroupModal;
